const celebrating = "/_app/immutable/assets/flexy-happy-young-man-celebrating-something.C2RpjKOq.svg";
export {
  celebrating as default
};
